import * as React from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";

import { cn } from "@/lib/utils";

const ScrollArea = ({
    className,
    children,
    ...props
}: React.ComponentProps<typeof ScrollAreaPrimitive.Root>) => (
    <ScrollAreaPrimitive.Root
        className={cn("relative overflow-hidden", className)}
        {...props}
    >
        <ScrollAreaPrimitive.Viewport className="h-full w-full rounded-[inherit] pr-3">
            {children}
        </ScrollAreaPrimitive.Viewport>
        <ScrollBar />
        <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
);
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

// Needed because shadCN's scroll area won't work with a Dialog => ScrollArea => Form nesting
export const scrollbarClassName =
    "scrollbar-thin scrollbar-thumb-rounded scrollbar-track-transparent scrollbar-thumb-transparent hover:scrollbar-thumb-scrollbar active:scrollbar-thumb-scrollbar-active overflow-x-auto overflow-y-auto pr-0.5 transition-all duration-300";
export const ScrollAreaSafe = ({
    children,
    containerClassName,
    className,
    ref,
    ...props
}: {
    children: React.ReactNode;
} & React.ComponentProps<"div"> & { containerClassName?: string }) => {
    return (
        <div
            className={cn("relative overflow-hidden", containerClassName)}
            {...props}
        >
            <div
                className={cn(scrollbarClassName, "h-full w-full", className)}
                ref={ref}
            >
                {children}
            </div>
        </div>
    );
};

const ScrollBar = ({
    className,
    orientation = "vertical",
    ...props
}: React.ComponentProps<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>) => (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
        orientation={orientation}
        className={cn(
            "flex touch-none transition-colors select-none",
            orientation === "vertical" && "p-narrower h-full w-2.5",
            orientation === "horizontal" && "p-narrower h-2.5 flex-col",
            className,
        )}
        {...props}
    >
        <ScrollAreaPrimitive.ScrollAreaThumb className="bg-border bg-neutral-bold-default relative flex-1 rounded-full" />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
);
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;

export { ScrollArea, ScrollBar };
